export default function OrgInfoSection({ tenant }) {
  if (!tenant) return null;
  const sub = tenant.subscription || {};
  const inUse = sub.seats_used ?? tenant.user_count;
  const paid = sub.seats_purchased;
  const cap = sub.max_users;
  const paidLabel = paid == null ? "∞" : paid;
  const capLabel = cap == null ? "∞" : cap;
  return (
    <section className="border border-zinc-950 mt-8">
      <div className="border-b border-zinc-950 bg-zinc-950 text-white px-4 py-2 font-mono text-[11px] tracking-[0.2em] uppercase">org.info</div>
      <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-6">
        <div>
          <div className="label-sm text-zinc-500">Organization</div>
          <div className="font-display font-bold text-xl mt-1" data-testid="org-name">{tenant.name}</div>
        </div>
        <div>
          <div className="label-sm text-zinc-500">Owner</div>
          <div className="font-mono text-sm mt-1">{tenant.owner_email}</div>
        </div>
        <div>
          <div className="label-sm text-zinc-500">Seats</div>
          <div className="font-display font-bold text-xl mt-1 tnum" data-testid="org-seats-inuse">
            {inUse}<span className="text-zinc-400 text-sm"> in use</span>
          </div>
          <div className="mt-1 text-[11px] font-mono text-zinc-500 tnum" data-testid="org-seats-breakdown">
            <span data-testid="org-seats-paid">Paid: {paidLabel}</span>
            <span className="text-zinc-300 mx-1.5">·</span>
            <span data-testid="org-seats-cap">Plan cap: {capLabel}</span>
          </div>
        </div>
        <div>
          <div className="label-sm text-zinc-500">Current Plan</div>
          <div className="font-display font-bold text-xl mt-1 text-[#FF3E00]" data-testid="current-plan">{sub.name}</div>
        </div>
      </div>
    </section>
  );
}
